// M-Y1 fix (docs/lot-lifecycle-vs-concerns-audit.md §2, §5 PR-α1 / U1): the
// lot column must never hide a row's already-saved value just because the
// *current* roster (`availableLots`) for the production unit happens to be
// empty (e.g. right after the lot moved out). Saved values are Category A
// (frozen Tier-A-adjacent display) and render as plain text, independent of
// the roster. The roster-emptiness notice is scoped to the create/edit slot,
// shown only when there is nothing saved yet to display.
export type WaterLotCellDisplayMode = 'select' | 'savedLabel' | 'emptyRoster'

export const resolveWaterLotCellDisplayMode = (args: {
  savedLotLabel: string
  hasUnmappedLot: boolean
  availableLotsCount: number
  /**
   * The row's lot lives in another production unit now (transferred out after
   * producing readings here). Render its saved label read-only rather than a
   * lot dropdown stuck on "(ninguno)". Track A finding 4.2 (Water parity).
   */
  isForeignLot?: boolean
}): WaterLotCellDisplayMode => {
  if (args.isForeignLot && args.savedLotLabel.trim() && !args.hasUnmappedLot) return 'savedLabel'
  if (args.availableLotsCount > 0) return 'select'

  const trimmedLabel = args.savedLotLabel.trim()
  if (trimmedLabel && !args.hasUnmappedLot) return 'savedLabel'

  return 'emptyRoster'
}
